var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2799 21.1867C27.4316 23.1927 26.1049 24.9603 24.4157 26.3351C22.7265 27.7099 20.7262 28.6499 18.5898 29.0731C16.4534 29.4962 14.2458 29.3895 12.1601 28.7624C10.0744 28.1353 8.17405 27.0068 6.62525 25.4756C5.07644 23.9443 3.92631 22.057 3.2754 19.9786C2.62449 17.9002 2.49264 15.694 2.89135 13.5529C3.29007 11.4117 4.20721 9.40085 5.56261 7.69605C6.91801 5.99125 8.6704 4.64444 10.6666 3.77335",
    stroke: "#002E19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 16C29.3333 14.249 28.9885 12.5152 28.3184 10.8975C27.6483 9.27987 26.6662 7.81001 25.4281 6.5719C24.19 5.33378 22.7201 4.35166 21.1024 3.6816C19.4848 3.01153 17.751 2.66666 16 2.66666V16H29.3333Z",
    stroke: "#002E19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart32);
export default __webpack_public_path__ + "static/media/pie-chart_32.d07465386b90602fdd0411c850e64e8b.svg";
export { ForwardRef as ReactComponent };